<template lang="pug">
Auth(:redirectWithLoginFailed="true")
  Header(:content="headerContent")
  div.wrap-edit-frame-by-drawing
    div(v-if="isSaving").wrap-saving-line
      v-progress-linear(:color="pallete.$active_color" indeterminate)
    ModuleEditFrameByDrawing(ref="editFrameByDrawing"
      v-if="frame" :frame="frame" :enableToSave="enableToSave"
      @onSave="onSave"
      @activateSaveBtn="activateSaveBtn")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-edit-frame-by-drawing {
  width: 100%;
  min-height: $device_height;
  .wrap-saving-line {
    position: fixed;
    top: 0; width: 100%;
    z-index: 101;
    // top: calc(#{$header_height} + #{$sub_header_height});
  }
}
</style>

<script>
import database from '@/database'
import { storage } from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header'
import ModuleEditFrameByDrawing from '@/components/module/ModuleEditFrameByDrawing'
// import ModuleEditFrameByDrawing from '@/components/module/ModuleEditFrameByDrawingOld'

export default {
  components: {
    Auth,
    Header,
    ModuleEditFrameByDrawing
  },
  data () {
    return {
      headerContent: {
        title: '絵を編集',
        left: {
          icon: 'mdi-trackpad',
          action: this.toPage
          // to: this.pagePath
          // action: this.onBack
        },
        right: {
          label: '保存',
          color: '#757575', // '#1DC1AC', // this.pallete.$active_color,
          action: this.onSave
        }
      },
      frame: null,
      isSaving: false
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    pagePath () {
      const rp = this.$route.params
      return `/edit-comic/${rp.comicId}/${rp.episodeId}/${rp.pageId}`
    },
    enableToSave () {
      return this.headerContent.right.color === this.pallete.$active_color
    }
  },
  async created () {
    const rp = this.$route.params
    this.frame = await database
      .frameCollection(rp.comicId, rp.episodeId, rp.pageId)
      .findById(rp.frameId)
  },
  methods: {
    async onSave () {
      if (this.isSaving) return
      this.isSaving = true
      this.deactivateSaveBtn()

      const editFrameByDrawing = this.$refs.editFrameByDrawing
      const base64 = await editFrameByDrawing.canvas.toDataURL()
      
      const base64Resized = await this.resizeImage(base64)
      const imgURL = await this.uploadImg(base64Resized)

      let updateParams = { frameImg: imgURL, updatedAt: new Date() }
      if (this.frame.frameImg) {
        const frameImgHistories = this.frame.frameImgHistories ? 
          this.frame.frameImgHistories : []
        frameImgHistories.unshift({
          img: this.frame.frameImg,
          archievedAt: new Date()
        })
        updateParams.frameImgHistories = frameImgHistories
      }

      const rp = this.$route.params
      await database.frameCollection(rp.comicId, rp.episodeId, rp.pageId)
        .update(rp.frameId, updateParams)

      editFrameByDrawing.isSaved = true
      this.isSaving = false

      this.$root.$emit('showNavigationMessage', {
        message: '保存しました', showOK: true
      })
    },
    async resizeImage (base64image) {
      const image = await this.loadImage(base64image, 'Anonymous')

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const THUMBNAIL_WIDTH = 1600
      const THUMBNAIL_HEIGHT = 1600

      let width, height, ratio
      if (image.width > image.height) {
        // 横長の画像は横のサイズを指定値にあわせる
        ratio = image.height / image.width
        width = THUMBNAIL_WIDTH
        height = THUMBNAIL_WIDTH * ratio
      } else {
        // 縦長の画像は縦のサイズを指定値にあわせる
        ratio = image.width / image.height
        width = THUMBNAIL_HEIGHT * ratio
        height = THUMBNAIL_HEIGHT
      }
      canvas.setAttribute('width', width)
      canvas.setAttribute('height', height)

      ctx.clearRect(0, 0, width, height)
      ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height)

      return canvas.toDataURL()
    },
    async uploadImg (base64) {
      const fileId = this.getUniqueStr()
      const storageRef = storage.ref()
      const ref = storageRef.child(`USER/${this.uid}/FRAME/${this.$route.params.frameId}/${fileId}`)
      const imgURL = await ref
        .putString(base64.split(',')[1], 'base64', {contentType: 'image/png'})
        .then(async (snapshot) => {
          return await snapshot.ref.getDownloadURL()
          .then(async downloadURL => downloadURL)
        })
      return imgURL
    },
    async toPage () {
      if (this.enableToSave) {
        const go = await window.customConfirm('ページを移動しますか？*編集内容が保存されていません')
        if (!go) return
      }
      this.$router.push(this.pagePath)
    },
    activateSaveBtn () {
      this.headerContent.right.color = this.pallete.$active_color
    },
    deactivateSaveBtn () {
      this.headerContent.right.color = this.pallete.$secondary_text_color
    }
  }
}
</script>
